import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const adcalculatorEndPoints = ApiEndpoints.calculator.calculatorCreate;

export default function AddCalculator() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        annual_software_cost:"",
        root_opt: "",
        root_opt_fleet_efficiency: "",
        root_opt_driver: "",
        root_opt_fuel: "",
        fuel_cost_per_litre: "",
        annual_days: "",
        working_hours_per_day: "",
        date: new Date(),
    });

    const [status, setStatus] = useState("");

    const StatusData = [
        { _id: "1", name: "Disable" },
        { _id: "0", name: "Enable" },
    ];

    // Handle input change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // Handle status change
    const handleStatusChange = (e) => {
        setStatus(e.target.value);
    };

    // Submit form
    const handleSubmit = async (event) => {
        event.preventDefault();
        const {
            annual_software_cost,
            root_opt,
            root_opt_fleet_efficiency,
            root_opt_driver,
            root_opt_fuel,
            fuel_cost_per_litre,
            annual_days,
            working_hours_per_day,
        } = formData;

        // Validation
        if (
            !annual_software_cost||
            !root_opt ||
            !root_opt_fleet_efficiency ||
            !root_opt_driver ||
            !root_opt_fuel ||
            !fuel_cost_per_litre ||
            !annual_days ||
            !working_hours_per_day
        ) {
            toast.error("All fields are required.");
            return;
        }
        const payload = {
            ...formData,
        };

        try {
            const response = await ApiRequest("POST", adcalculatorEndPoints, payload);
            toast.success(response.message || "Created Successfully");
            navigate("/calculator");
        } catch (error) {
            console.error("API Error:", error);
            toast.error("Something went wrong!");
        }
    };

    return (
        <>
            <AdminHeader pagename="Add Calculator" />
            <div className="add-content-page">
                <form id="newsAdd" onSubmit={handleSubmit}>
                    <div className="add-content-wrap">
                        <div className="row">

                             <div className="col-lg-4">
                                <div className="add-page-inputs">
                                    <div className="label-wrap-add">
                                        <label>Software Cost (Monthly Per Vicle)<small>*</small></label>
                                    </div>
                                    <input name="annual_software_cost"
                                        value={formData.annual_software_cost} onChange={handleChange} type="text" className="form-control" placeholder="Enter Software Cost" />
                                </div>
                            </div>



                            <div className="col-lg-4">
                                <div className="add-page-inputs">
                                    <div className="label-wrap-add">
                                        <label>Root Opt<small>*</small></label>
                                    </div>
                                    <input name="root_opt"
                                        value={formData.root_opt} onChange={handleChange} type="text" className="form-control" placeholder="Enter Root Opt " />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="add-page-inputs">
                                    <div className="label-wrap-add">
                                        <label>Fleet Efficiency<small>*</small></label>
                                    </div>
                                    <input onChange={handleChange} name="root_opt_fleet_efficiency" value={formData.root_opt_fleet_efficiency} type="text" className="form-control" placeholder="Enter Fleet Efficiency" />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="add-page-inputs">
                                    <div className="label-wrap-add">
                                        <label>Root Opt Driver<small>*</small></label>
                                    </div>
                                    <input onChange={handleChange} name="root_opt_driver" value={formData.root_opt_driver} type="text" className="form-control" placeholder="Root Opt Driver" required />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="add-page-inputs">
                                    <div className="label-wrap-add">
                                        <label>Root Opt Fuel<small>*</small></label>
                                    </div>
                                    <input onChange={handleChange} name="root_opt_fuel" value={formData.root_opt_fuel} type="text" className="form-control" placeholder="Root Opt Fuel" required />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="add-page-inputs">
                                    <div className="label-wrap-add">
                                        <label>Fuel Cost Per Litre<small>*</small></label>
                                    </div>
                                    <input onChange={handleChange} name="fuel_cost_per_litre" value={formData.fuel_cost_per_litre} type="text" className="form-control" placeholder="Fuel Cost Per Litre" required />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="add-page-inputs">
                                    <div className="label-wrap-add">
                                        <label>Annual Days<small>*</small></label>
                                    </div>
                                    <input onChange={handleChange} name="annual_days" value={formData.annual_days} type="text" className="form-control" placeholder="Annual Days" required />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="add-page-inputs">
                                    <div className="label-wrap-add">
                                        <label>Working Hours Per Day<small>*</small></label>
                                    </div>
                                    <input onChange={handleChange} name="working_hours_per_day" value={formData.working_hours_per_day} type="text" className="form-control" placeholder="Working Hours Per Day" required />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <button type="submit" form="newsAdd" className="default-btn">publish <span></span></button>
            </div>
        </>
    );
}

